import CalculStatistiqueDetailController from './calcul.statistique.detail.controller';

export default {
    template: require('./calcul.statistique.detail.html'),
    controller: CalculStatistiqueDetailController
};
